var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2.553 9.608A4.49 4.49 0 016 8h36a4.49 4.49 0 013.511 1.685l.003.004A4.48 4.48 0 0146.5 12.5v24c0 2.484-2.016 4.5-4.5 4.5H6a4.501 4.501 0 01-4.5-4.5v-24c0-1.063.369-2.04.986-2.81l.003-.005c.02-.026.042-.052.064-.077zM4.5 13.125V36.5A1.5 1.5 0 006 38h36a1.5 1.5 0 001.5-1.5V13.125L28.949 24.317a8.115 8.115 0 01-9.898 0L4.5 13.125zM41.342 11H6.658l14.223 10.939a5.115 5.115 0 006.238 0L41.342 11z"}));
}

Mail.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = Mail;

Mail.default = Mail;
